"use strict";
//require('slick-carousel');
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitVastuullisuus = void 0;
function InitVastuullisuus() {
    const setHeroMargin = () => {
        let leadHeight = jQuery('body .content-on-image').height();
        let addMargin = leadHeight - 376;
        if ((window.innerWidth > 1200) && addMargin > 0) {
            addMargin -= 20;
            jQuery('body .content-wrapper > article#main-content > div >.fullbleed.row.vastuullisuus:first-child .o-full-width-content-block:not(.fullscreen) > div').css('margin-bottom', addMargin + 'px');
        }
        else {
            jQuery('body .content-wrapper > article#main-content > div >.fullbleed.row.vastuullisuus:first-child .o-full-width-content-block:not(.fullscreen) > div').css('margin-bottom', '0');
        }
    };
    // Init
    if (window.innerWidth > 1200) {
        setTimeout(() => {
            setHeroMargin();
        }, 100);
    }
    jQuery(window).on('resize', function () {
        setHeroMargin();
    });
}
exports.InitVastuullisuus = InitVastuullisuus;
